<template>
  <router-view/>
  <div class="fixed right-0 bottom-0 z-50">
    <div v-for="(error, index) in errorList" :key="`err-${index}`" class="mx-8 shadow-xl my-4">
      <ErrorMessage
        :message="error.message"
        :code="error.code ? `${error.code}` : ''"
        :title="error.title ? error.title : 'Error'"
        @close="handleErrorClick(index)"
      />
    </div>
  </div>
</template>

<script>
/**
 * @author Nic Ballesteros (with auto-generated code)
 * @description Root of the component tree
 * Updated 12/27/22
 */
import ErrorMessage from '@/components/ErrorMessage.vue';

export default {
  name: 'App',
  components: {
    ErrorMessage,
  },
  inject: ['errorList'],
  mounted() {
    document.title = 'Golf Guru';
  },
  methods: {
    handleErrorClick(index) {
      this.errorList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
